<button [type]="type" mat-stroked-button [disabled]="disabled" color="primary">
  <ng-content></ng-content>
</button>
